import { KIT } from "@/constants/testIds";

export const SectionHeading = ({ eyebrow, title, note, action }) => (
  <div
    data-testid={KIT.sectionHeading}
    className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between sm:gap-4"
  >
    <div className="space-y-1.5">
      {eyebrow && <p className="ps-eyebrow">{eyebrow}</p>}
      <h2 className="font-display text-xl font-semibold text-brand-teal sm:text-2xl">{title}</h2>
      {note && <p className="max-w-prose text-sm leading-relaxed text-muted-foreground">{note}</p>}
    </div>
    {action && <div className="shrink-0">{action}</div>}
  </div>
);
